var map = {
	"app/views/pages/auth/auth.module": [
		"./src/app/views/pages/auth/auth.module.ts"
	],
	"app/views/pages/dashboard/dashboard.module": [
		"./src/app/views/pages/dashboard/dashboard.module.ts",
		"default~app-views-pages-dashboard-dashboard-module~app-views-pages-master-master-module",
		"app-views-pages-dashboard-dashboard-module"
	],
	"app/views/pages/master/master.module": [
		"./src/app/views/pages/master/master.module.ts",
		"default~app-views-pages-dashboard-dashboard-module~app-views-pages-master-master-module",
		"app-views-pages-master-master-module"
	],
	"app/views/themes/demo1/content/builder/builder.module": [
		"./src/app/views/themes/demo1/content/builder/builder.module.ts",
		"app-views-themes-demo1-content-builder-builder-module"
	],
	"app/views/themes/demo1/theme.module": [
		"./src/app/views/themes/demo1/theme.module.ts",
		"app-views-themes-demo1-theme-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;